import { getResourcesFromPlatform } from '../../../coveo-platform/_imports/coveo-platform.common';
import ResourceCard from '../../../resources/resource-banner/resource-cards/resource-card.vue.js';
import { decodeHtml } from '../../../_imports/shared/vue-utils.common.js';

export default {
    mixins: [decodeHtml],
    components: {
        ResourceCard
    },
    data() {
        return {
            searchInput: '',
            resultsRaw: [],
            resultsLoading: true,
            resultsAbortController: null,
            querySuggestionsRaw: [],
            querySuggestionsLoading: true,
            querySuggestionsAbortController: null
        }
    },
    computed: {
        querySuggestions() {
            if (this.querySuggestionsRaw.length) {
                return this.querySuggestionsRaw.map((querySuggestion) => ({
                    text: querySuggestion.expression
                }));
            }

            if (this.data.topQueries?.length) {
                return this.data.topQueries;
            }

            return [];
        },
        results() {
            if (this.resultsRaw.length) {
                return this.resultsRaw;
            }

            return this.data.featuredResults.map((featuredResult) => ({
                externalUrl: featuredResult.externalUrl || featuredResult.registrationlink,
                landingUrl: featuredResult.registrationlink || featuredResult.landingUrl,
                title: featuredResult.title,
                thumbnail: featuredResult.thumbnail,
                type: featuredResult.type
            }));
        },
        querySuggestionsTitle() {
            return this.decodeHtml(this.querySuggestionsRaw.length ? this.data.querySuggestionsText : this.data.topQueriesText);
        },
        resultsTitle() {
            return this.decodeHtml(this.resultsRaw.length ? this.data.resultsText : this.data.featuredResultsText);
        },
        hasSearchInput() {
            return this.searchInput.length;
        }
    },
    watch: {
        searchInput: {
            handler() {
                this.updateQuerySuggestions();
                this.updateResults();
            },
            immediate: true
        },
        results: {
            handler() {
                setTimeout(() => {
                    document.querySelector('[am-main-navigation]').dispatchEvent(new CustomEvent('refreshstyles'));
                }, 0);
            },
            immediate: true
        },
        querySuggestions: {
            handler() {
                setTimeout(() => {
                    document.querySelector('[am-main-navigation]').dispatchEvent(new CustomEvent('refreshstyles'));
                }, 0);
            },
            immediate: true
        }
    },
    methods: {
        renderQuerySuggestionLink(querySuggestion) {
            if (querySuggestion.link) {
                return querySuggestion.link.url;
            }

            return `${this.data.searchPage}#q=${querySuggestion.text}`;
        },
        updateQuerySuggestions() {
            this.querySuggestionsLoading = true;

            if (!this.searchInput) {
                this.querySuggestionsRaw = [];
                this.querySuggestionsLoading = false;
                return;
            }

            const config = {
                headers: {
                    'Authorization': `Bearer ${this.data.searchApi.apiToken}`
                }
            };

            const query = {
                locale: lang
            };

            if (CoveoWebsite?.coveoPlatform?.env) {
                query.context = {
                    web_env: CoveoWebsite.coveoPlatform.env
                };
            }

            if (this.data.searchApi.searchHub) {
                query.searchHub = this.data.searchApi.searchHub;
            }

            if (this.data.searchApi.tab) {
                query.tab = this.data.searchApi.tab;
            }

            query.q = this.searchInput;

            if (this.querySuggestionsAbortController) {
                this.querySuggestionsAbortController.abort();
            }

            this.querySuggestionsAbortController = new AbortController();

            config.signal = this.querySuggestionsAbortController.signal;

            http.post(`https://${this.data.searchApi.orgId}.org.coveo.com/rest/search/v2/querySuggest?organizationId=${this.data.searchApi.orgId}`, query, config)
                .then((response) => {
                    if (response?.data) {
                        this.querySuggestionsRaw = response.data.completions;
                        this.querySuggestionsLoading = false;
                    }
                })
                .catch((err) => {
                    if (err?.message !== 'canceled') {
                        throw new Error(err);
                    }
                });;
        },
        updateResults() {
            this.resultsLoading = true;

            if (!this.searchInput) {
                this.resultsRaw = [];
                this.resultsLoading = false;
                return;
            }

            const payload = {
                coveoPlatform: this.data.searchApi
            };

            const query = {
                locale: lang,
                sortCriteria: 'relevancy'
            };

            if (CoveoWebsite?.coveoPlatform?.env) {
                query.context = {
                    web_env: 'web01'
                };
            }

            const aqConditions = [`@culture='${lang}'`];

            if (this.data.searchApi.aq) {
                aqConditions.push(this.data.searchApi.aq.replaceAll('@@', '@'));
            }

            if (this.data.searchApi.searchHub) {
                query.searchHub = this.data.searchApi.searchHub;
            }

            if (this.data.searchApi.tab) {
                query.tab = this.data.searchApi.tab;
            }

            query.aq = aqConditions.join(' AND ');
            query.q = this.searchInput;

            payload.query = query;

            if (this.resultsAbortController) {
                this.resultsAbortController.abort();
            }

            this.resultsAbortController = new AbortController();

            payload.abortController = this.resultsAbortController;

            getResourcesFromPlatform(payload)
                .then(({ resources }) => {
                    this.resultsRaw = resources;
                    this.resultsLoading = false;
                });
        },
        resetSearch() {
            this.searchInput = '';
        },
        triggerSearch() {
            if (this.searchInput) {
                window.location.href = `${this.data.searchPage}#q=${this.searchInput}`;
            }
        }
    },
    mounted() {
        this.$refs.searchBox.addEventListener('keyup', (event) => {
            if (event.key === 'Enter') {
                this.triggerSearch();
            }
        })
    }
};